import * as React from 'react';
import { MatchCards } from '../../view/match-cards/MatchCards';
import { connect } from 'react-redux';
import SwipeableViews from 'react-swipeable-views';
import { setActiveFilter } from '../../day-filter/reducer';
import { AppProps, BeachRootState } from '../..';
import { Dispatch, bindActionCreators } from 'redux';
import './BeachMatchesOverview.scss';
import { NavLink, useParams } from 'react-router-dom';
import { getHierarchiesPath } from '../../utils';

const Swipeable: any = SwipeableViews

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
  setActiveFilter
}, dispatch)

interface OwnProps {
  appProps: AppProps
  favoritesRoute?: boolean
}

const mapStateToProps = (state: BeachRootState, props: OwnProps) => {

  let matchDays = state.tickerState.matchDays
  const matchSeries = state.tickerState.matchSeries
  const gender = state.filterNav.gender

  if (props.favoritesRoute) {
    matchDays = matchDays.map(m => {
      return {
        ...m,
        matches: m.matches.filter(m => {
          if (gender && matchSeries[m.matchSeries].gender !== gender) {
            return
          }
          return state.favorites.indexOf(m.id) > -1
        })
      }
    })
  }

  return {
    matchDays,
    matchSeries,
    matchStatesByUuid: state.tickerState.matchStatesByUuid,
    settings: state.tickerState.settings,
    loading: state.tickerState.loading,
    error: state.tickerState.error,
    gender: state.filterNav.gender,
    activeFilterDay: state.dayFilter.activeFilterDay,
    favorites: state.favorites,
    hierarchies: state.tickerState.hierarchies
  }
}

type Props = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps> & OwnProps

const MatchesOverview = (props: Props) => {

  const handleChangeIndex = (index: number) => {
    props.setActiveFilter(index)
  }

  const {
    loading,
    appProps,
    activeFilterDay,
    matchStatesByUuid,
    favorites,
    favoritesRoute,
    matchSeries,
    gender,
    hierarchies,
    error
  } = props

  let matchDays = props.matchDays

  const { matchseriesId } = useParams()

  const activeMatchSeries = matchseriesId ? matchSeries[matchseriesId] : null

  if (activeMatchSeries) {
    matchDays = matchDays.map(m => {
      return {
        ...m,
        matches: m.matches.filter(m => m.matchSeries === matchseriesId)
      }
    })
  }

  return <div className={'MatchesOverview'}>
    <a href={appProps.adBannerUrl} className="AdBanner"></a>
    {favoritesRoute && <h1>Favoriten</h1>}
    {activeMatchSeries && <div className="MatchSeriesNavigation">
        <NavLink className="BeachHierarchyLink" key={activeMatchSeries.hierarchy} to={getHierarchiesPath(activeMatchSeries.hierarchy)}>
          {hierarchies.find(h => h.id === activeMatchSeries.hierarchy)?.name || 'Unbekanntes Hierarchie'} {gender && (gender === 'FEMALE' ? "Damen" : (gender === 'MALE' ? 'Herren' : 'Mixed'))}
        </NavLink>
        <div className="ActiveMatchSeries">{activeMatchSeries.name}</div>
      </div>
      }
    {error && <h1>{error}</h1>}
    {!loading && activeMatchSeries
      && <div className="MatchDays">{
        <Swipeable
          style={{ "paddingBottom": "50px", "flex": "1 0 auto", "display": "flex", "flexDirection": "column" }}
          containerStyle={{ "flex": "1 0 auto", "display": "flex" }}
          animateHeight resistance index={activeFilterDay}
          onChangeIndex={handleChangeIndex}>
          {
            matchDays.map((matchDay, idx) => {
              return matchDay?.matches?.length === 0 && !loading
                ? <h1 key={idx} style={{ "padding": "50px" }}>An diesem Tag finden keine Spiele statt.</h1>
                : <MatchCards key={idx}
                      matchDay={matchDay}
                      matchStatesByUuid={matchStatesByUuid}
                      matchSeries={props.matchSeries}
                      favorites={favorites} />
            })
          }
        </Swipeable>
      }</div>
    }
  </div>

}

export default connect(mapStateToProps, mapDispatchToProps)(MatchesOverview)
